/* eslint prefer-template: 0 */
import { toLower } from 'lodash';
import { formatDate } from '../../utils/date';

const getHorseMetaTitle = (page, name) => {
    const titleConfig = {
        'weatherbys-overview': 'Weatherbys Overview',
        'sire-reference': 'Sire Reference',
        progeny: 'Progeny',
        'progeny-dam': 'Progeny',
        'progeny-dams-sire': 'Progeny Dam\'s Sire',
        'progeny-statistics': 'Progeny Statistics',
        'progeny-results': 'Progeny Results',
        'progeny-entries': 'Progeny Entries',
        nicks: 'Nicks',
        'fee-history': 'Fee History',
        'sales-statistics': 'Sales Statistics',
        'sales-results': 'No title',
        'sales-entries': 'No title',
        'progeny-sales': 'Progeny Sales',
        form: 'Race Record & Form',
        'my-ratings': 'Form & My Ratings',
        entries: 'Race Entries',
        stats: 'Race Stats',
        quotes: 'Quotes From Connections',
        pedigree: 'Horse Pedigree',
        sales: 'Sales Details',
        notes: 'Personal Notes',
    };

    return `${name} | ${titleConfig[page]} | Racing Post`;
};

const getHorseMetaDescription = (page, {
    age,
    horseDateOfBirth,
    horseColourCode,
    horseSexCode,
    sireHorseName,
    sireAvgFlatWinDist,
    damHorseName,
    damCountryOriginCode,
    damSireHorseName,
    damSireAvgFlatWinDist,
    trainerName,
    ownerName,
    breederName,
    horseName,
    horseCountryOriginCode: countryCode,
    sireStatus,
}) => {
    const horseDetails = `${age} (${formatDate(horseDateOfBirth, 'DDMMMYY')}
        ${toLower(horseColourCode)} ${toLower(horseSexCode)});
        ${sireHorseName} (${sireAvgFlatWinDist}f) - ${damHorseName}
        (${damCountryOriginCode}) (${damSireHorseName} (${damSireAvgFlatWinDist || ''}f));
        Trainer ${trainerName}; Owner ${ownerName}; Breeder ${breederName}`;

    const descriptionConfig = {
        'weatherbys-overview':
            `Weatherbys Overview for ${horseName} available on Racing Post Bloodstock.
            Profile page includes Stud Fee, Sire, Dam, Dam's Sire, Standing, Sire Comment,
            Breeder, Trainer and Owner.`,
        'sire-reference':
            `Weatherbys Sire Reference for ${horseName} available on Racing Post Bloodstock.
            Copyright protected. All rights reserved.`,
        progeny:
            `View detailed progeny statistics for ${horseName} including wins,
            runs and total earnings`,
        'progeny-dams-sire':
            `View detailed dam's sire progeny statistics for ${horseName} including wins,
            runs and total earnings`,
        'progeny-statistics':
            `Stallion statistics from the Racing Post.
            View wins, runs, earnings and Racing Post Ratings.`,
        'progeny-results':
            `Historical Progeny Results for ${horseName}.
            Includes statistics on course run, course conditions and prize earnings.`,
        'progeny-entries': sireStatus ?
            `Historical Progeny Entries for ${horseName}. Filter by season or race.` :
            `Full list of progeny entries for ${horseName} listed by race and date.`,
        nicks:
            `View the family related data of ${horseName} including statistics such as wins,
            win percentage and total earnings.`,
        'fee-history':
            `Research yearly Stud fee's for ${horseName} on the Racing Post.
            The most comprehensive Horse Racing statistics available today.`,
        'sales-statistics':
            `In depth sales statistics for ${horseName}.
            Get the most comprehensive Horse Racing statistics available from the Racing Post.`,
        'sales-results': 'No description',
        'sales-entries': 'No description',
        'progeny-sales':
            `Progeny sales data brought to you by the Racing Post.
            Track prices, sales, buyer information and more.`,
        form:
            `${horseName} statistics and form.
            View results and future entries as well as statistics by course,
            race type and prize money.`,
        'my-ratings':
            `${horseName} statistics and form.
            View results and future entries as well as statistics by course,
            race type and prize money.`,
        entries:
            `Forthcoming race entries for ${horseName}.
            Includes date entered, race time and latest betting odds.`,
        stats:
            `${horseName} Race Statistics provided by the Racing Post.
            Broken down by course, distance, going, month, jockey and class.`,
        quotes: `Quotes from the connections of ${horseName}. ${horseDetails}`,
        pedigree: `${horseName} Pedigree. Stallion and Dam details provided.`,
        sales: `${horseName} (${countryCode}) Sales Details. ${horseDetails}`,
        notes:
            `Access the "My Notes" section of individual horse profiles.
            Providing notes according to race type as well as being able
            to provide your own horse ratings`,
    };

    return descriptionConfig[page];
};

const getHorseMetaData = (page, profile) => ({
    title: getHorseMetaTitle(page, profile.horseName),
    description: getHorseMetaDescription(page, profile),
});

export default getHorseMetaData;




// WEBPACK FOOTER //
// ./src/js/shared/metaData/getHorseMetaData.js